import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  text-align: center;
  padding-top: 72px;
  padding-bottom: 72px;

  .component_social_account_box {
    margin: 24px 0;
    width: 522px;
    background-color: ${color.grey3};
    border-radius: 12px;
    padding: 12px 24px;
    padding-right: 40px;
    display: inline-block;
    color: ${color.black2};

    .ant-avatar-string {
      line-height: 45px !important;
    }
  }

  .component_social_account_content {
    line-height: 140%;
    text-align: left;

    .font-caption {
      max-width: 237px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .component_social_account_notes {
    max-width: 656px;
    text-align: center;
    margin: auto;
  }

  .component_social_account {
    display: flex;
    align-items: center;
    white-space: nowrap;
    justify-content: flex-end;
    text-align: right;
    height: 100%;

    .anticon {
      font-size: 18px;
      margin-right: 5px;
    }
  }
`;

export default Wrapper;
